import { Helper } from "../util/helper.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import React from "react";
export class CheckBox extends React.Component<CheckBoxProps, any>{
    private id = null;
    private inputRef: HTMLElement;
    private _checkBox: kendo.ui.CheckBox;

    constructor(props: CheckBoxProps) {
        super(props);
        this.id = "ckb-" + props.field.name + "-" + kendo.guid();
        this.state = {
            value: this.props.value
        };
    }

    componentDidUpdate(prevProps: Readonly<CheckBoxProps>) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value }, () => this._checkBox.check(this.state.value));
        }
        if (prevProps.disabled !== this.props.disabled) {
            this.setState({}, () => this._checkBox.enable(!this.props.disabled));
        }
    }

    componentDidMount() {
        this._checkBox = $(this.inputRef).kendoCheckBox({
            checked: this.state.value,
            label: this.props.field.labelAndControlCombined ? this.props.field.name : "",
            enabled: !this.props.disabled,
            change: (ev) => {
                let value = ev.sender.check();
                this.props.onChange(this.props.field, value, null)
            }
        }).data("kendoCheckBox");

    }

    render() {
        return (
            <div className="checkbox__container">
                <input type="checkbox" id={this.id} ref={(ref) => { this.inputRef = ref }} />
            </div>
        );
    }
}

export class CheckBoxStatus extends React.Component<CheckBoxProps, any>{
    render() {
        const bool = (Helper.hasValue(this.props.value) && this.props.value == true);
        const style = bool ? "green" : "red";
        const icon = bool ? "fa-solid fa-bold fal fa-check" : "fa-solid fa-bold fal fa-times";
        return (
            <div className="checkbox-status__container">
                <i className={icon} style={{ color: style, width: "20px", textAlign: "center" }} />
                {
                    this.props.field.labelAndControlCombined ? <label style={{ marginLeft: "4px" }}>{this.props.field.name}</label> : null
                }
            </div>
        );
    }
}

export interface CheckBoxProps extends BaseComponentProps {
    value: any;
    field: CheckBoxField;
}

interface CheckBoxField extends BaseField {
}